export function ErrorAlert({ message }) {
  if (!message) return null
  return (
    <div
      className="mb-3 p-2 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded text-sm text-red-600 dark:text-red-400"
      role="alert"
    >
      {message}
    </div>
  )
}
